import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        account,
    },
    //plugins: [createPersistedState()]
    plugins: [createPersistedState({
        key: 'apollotoken',
        storage: localStorage
    })]
    
});

export default store

// import Vue from 'vue';
// import Vuex from 'vuex';
// import createPersistedState from "vuex-persistedstate";
// import auth from "./modules/auth";
 
// Vue.use(Vuex);

// export default new Vuex.Store({
//   modules: {
//     auth
//   },
//   state: {},
//   mutations: {},
//   actions: {},
//   plugins: [createPersistedState({
//     key: "apollotoken",
//     paths: ["auth.login"], // auth.js �� login�����Ϻ��٥����������Ƥ��ݻ�����褦�ˤ���
//     storage: sessionStorage  // ����� localStorage ����¸���뤳�Ȥˤ���
//   })]
// })

// export default new Vuex.Store({
//     modules: {
//         auth
//     },
//     strict: true,
//     plugins: [createPersistedState({
//         key: 'apollotoken',
//         paths: ['auth.token'],
//         storage: sessionStorage
//     })]
// });

// import Vue from "vue";
// import Vuex from "vuex";
 
// Vue.use(Vuex);
 
// export default new Vuex.Store({
//     state: {
//         isLogin: false,
//         token:null,
//         username:null,
//     },
//     mutations: {
//         resetState (state) {
//             state.isLogin=false;
//             state.token=null;
//             state.username=null;
//         }
//     },
//     actions: {
//         clearState ({ commit }) {
//             commit('resetState');
//         },
//     }
// });
